import { render, staticRenderFns } from "./precautions.vue?vue&type=template&id=eba176fe&scoped=true"
import script from "./precautions.vue?vue&type=script&lang=js"
export * from "./precautions.vue?vue&type=script&lang=js"
import style0 from "./precautions.vue?vue&type=style&index=0&id=eba176fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba176fe",
  null
  
)

export default component.exports